import React from 'react';

const Process = () => {
  const steps = [
    {
      title: 'Konsultacja',
      description: 'Bezpłatna analiza Twojego pomysłu i możliwości finansowania.'
    },
    {
      title: 'Strategia',
      description: 'Opracowanie optymalnej strategii pozyskiwania środków.'
    },
    {
      title: 'Przygotowanie',
      description: 'Profesjonalne napisanie wniosku i przygotowanie dokumentacji.'
    },
    {
      title: 'Złożenie wniosku',
      description: 'Wsparcie w procesie składania.'
    }
  ];

  return (
    <section id="process" className="process">
      <div className="container">
        <div className="section-header">
          <div className="section-subtitle">Proces współpracy</div>
          <h2>Jak Przebiegała Będzie Nasza Współpraca?</h2>
          <p>
            Naasz sprawdzony proces gwarantuje skuteczność i transparentność 
            na każdym etapie realizacji projektu.
          </p>
        </div>

        <div className="process-steps">
          {steps.map((step, index) => (
            <div key={index} className="process-step">
              <div className="process-number">{index + 1}</div>
              <h4>{step.title}</h4>
              <p>{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Process;
